export default __webpack_public_path__ + "static/media/catherine-gagne.651b24f9.jpg";